import {
  CloseOutlined,
  DownloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Button, Image, message, Modal, Steps, Table, Tag } from "antd";
import { useState } from "react";
import * as XLSX from "xlsx";
import { axiosInstance } from "../../utils/axiosInterceptor";
import moment from "moment";
import "./purchaseHistoryModal.css";
import logo from "../../assets/marketPlacelogo.png";
import aapaLogo from "../../assets/LOGOAPP.png";

const PurchaseHistoryModal = ({
  open,
  hide,
  orderDetails,
  OrderNumber,
  current,
  pageSize,
  total,
  onPageChange,
  loading,
  orderStatus,
  orderDate,
}) => {
  const [pagination, setPagination] = useState(10);
  const columns = [
    {
      title: "Product Name",
      dataIndex: "ProductName",
      key: "ProductName",
      render: (prodName) =>
        prodName ? <span>{prodName}</span> : <span>-</span>,
    },
    {
      title: "NDC / Prod ID",
      dataIndex: "ProductCode",
      key: "ProductCode",
      align: "right",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
            {/* <EyeOutlined color="#888" onClick={()=>navigate('/product-details')}/> */}
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: (a, b) =>
        String(a?.ProductCode).localeCompare(String(b?.ProductCode)),
    },
    {
      title: "Amount",
      children: [
        {
          title: "Order Amount",
          dataIndex: "ordered_price",
          key: "ordered_price",
          align: "right",
          sorter: true,
          sorter: (a, b) =>
            parseFloat(a?.ordered_price || 0) -
            parseFloat(b?.ordered_price || 0),
          render: (total) =>
            total !== null && total !== undefined
              ? `$ ${Number(total || 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : "-",
        },
        {
          title: "Invoice Amount",
          dataIndex: "invoiced_price",
          key: "invoiced_price",
          align: "right",
          sorter: true,
          sorter: (a, b) =>
            parseFloat(a?.invoiced_price || 0) -
            parseFloat(b?.invoiced_price || 0),
          render: (total) =>
            total !== null && total !== undefined
              ? `$ ${Number(total || 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : "-",
        },
        // {
        //   title: "Shipment Amount",
        //   dataIndex: "shipped_price",
        //   key: "shipped_price",
        //   align: "right",
        //   sorter: true,
        //   sorter: (a, b) =>
        //     parseFloat(a.shipped_price || 0) - parseFloat(b.shipped_price || 0),
        //   render: (total) =>
        //     total !== null && total !== undefined
        //       ? `$ ${Number(total || 0).toLocaleString(undefined, {
        //           minimumFractionDigits: 2,
        //           maximumFractionDigits: 2,
        //         })}`
        //       : "-",
        // },
      ],
    },
    {
      title: "Quantity",
      children: [
        {
          title: "Order Quantity",
          dataIndex: "qty_ordered",
          key: "qty_ordered",
          align: "right",
          render: (val) => (val !== null && val !== undefined ? val : "-"),
          sorter: true,
          sorter: (a, b) =>
            parseFloat(a?.qty_ordered || 0) - parseFloat(b?.qty_ordered || 0),
        },
        {
          title: "Invoice Quantity",
          dataIndex: "qty_invoiced",
          key: "qty_invoiced",
          align: "right",
          render: (val) => (val !== null && val !== undefined ? val : "-"),
          sorter: true,
          sorter: (a, b) =>
            parseFloat(a?.qty_invoiced || 0) - parseFloat(b?.qty_invoiced || 0),
        },
        // {
        //   title: "Shipment Quantity",
        //   dataIndex: "qty_shipped",
        //   key: "qty_shipped",
        //   align: "right",
        //   render: (val) => (val !== null && val !== undefined ? val : "-"),
        //   sorter: true,
        //   sorter: (a, b) =>
        //     parseFloat(a?.qty_shipped || 0) - parseFloat(b?.qty_shipped || 0),
        // },
      ],
    },
    {
      title: "Unit price",
      dataIndex: "unit_price",
      key: "unit_price",
      align: "right",
      render: (total) =>
        `$ ${Number(total || 0).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}` || "-",
      sorter: (a, b) => a?.unit_price - b?.unit_price,
    },
  ];

  const statusStepMap = {
    ORDER_SENT: 1,
    ACK_RECEIVED: 2,
    // INVOICED: 3,
    COMPLETED: 3,
  };

  let steps = [];
  let currentStep = 1;
  let stepStatus = "process";

  if (orderStatus === "ACK_REJECTED" || orderStatus === "REJECTED") {
    steps = [
      {
        title: "Order Sent",
      },
      {
        title: "Rejected",
      },
    ];

    currentStep = 1;
    stepStatus = "error";
  } else {
    steps = [
      {
        title: "Order Sent",
      },
      {
        title: "ACK Received",
      },
      // {
      //   title: "Invoiced",
      // },
      {
        title: "Completed",
      },
    ];

    currentStep = statusStepMap[orderStatus] ?? 1;
  }
  const getSteps = (status) => {
    switch (status) {
      case "ORDER_SENT":
        return [{ title: "ORDER SENT", status: "finish" }];

      case "ACK_RECEIVED":
        return [
          { title: "ORDER SENT", status: "finish" },
          { title: "ACK ACCEPTED", status: "finish" },
        ];

      case "INVOICED":
        return [
          { title: "ORDER SENT", status: "finish" },
          { title: "ACK ACCEPTED", status: "finish" },
          { title: "INVOICED", status: "finish" },
        ];

      case "COMPLETED":
        return [
          { title: "ORDER SENT", status: "finish" },
          { title: "ACK ACCEPTED", status: "finish" },
          { title: "INVOICED", status: "finish" },
          { title: "SHIPPED", status: "finish" },
        ];

      case "ACK_REJECTED":
      case "REJECTED":
        return [
          { title: "ORDER SENT", status: "finish" },
          { title: "REJECTED", status: "error" },
        ];

      default:
        return [];
    }
  };

  return (
    <Modal
      style={{ marginTop: "-60px" }}
      title={
        <div
          style={{
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 24px",
            marginLeft: -24,
            marginRight: -24,
            marginTop: -16,
            fontSize: "16px",
            fontWeight: 500,
            color: "#262626",
            display: "flex",
            alignItems: "center",
          }}
        >
          Order Details
        </div>
      }
      open={open}
      onCancel={hide}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="user-modal"
      closeIcon={<CloseOutlined />}
      footer={
        <div className="relative flex flex-col sm:flex-row items-center w-full mt-14 rounded-md">
          {/* Center Title (always center on desktop) */}
          <span className=" md:ml-[35%] text-[#000833] text-[18px] md:text-[22px] font-medium text-center">
            Powered by AdvantEdge
          </span>

          {/* Logo */}
          <div className="mt-2 sm:mt-0 sm:ml-auto flex justify-center">
            <svg
              width="215"
              height="28"
              viewBox="0 0 309 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M36.4812 17.4737L24.9961 1.06907C24.0012 -0.356356 21.9007 -0.356356 20.9057 1.06907L0.441442 30.2902C-0.332418 31.3962 -0.0621819 32.9076 1.04333 33.6818C2.14884 34.4559 3.65971 34.1856 4.43357 33.0796L22.9448 6.6233L32.5505 20.3491C32.6242 20.4597 32.6733 20.5212 32.6733 20.5335C32.9927 20.9881 33.1523 21.5411 33.1032 22.1432C33.0049 23.3474 31.9977 24.3059 30.7939 24.3674C29.8972 24.4165 29.1111 23.9741 28.6566 23.2983C28.632 23.2614 28.4478 23.0034 28.4478 23.0034L24.9593 18.0144C24.5171 17.3754 23.7923 16.9699 22.9571 16.9699C21.6059 16.9699 20.5249 18.0635 20.5249 19.403C20.5249 19.9068 20.6723 20.3737 20.9426 20.7669L24.6767 26.0877C25.5366 27.3288 26.7772 28.3118 28.2512 28.8402C29.0497 29.1229 29.9095 29.2703 30.8062 29.258C34.7001 29.1966 37.8324 26.1123 38.0043 22.2784C38.078 20.4597 37.5007 18.7885 36.4812 17.4737Z"
                fill="url(#paint0_linear_1_5286)"
              />
              <path
                d="M22.9503 16.9526C24.2939 16.9526 25.3836 18.044 25.3888 19.3912C25.3923 20.7366 24.2974 21.8297 22.9503 21.8297C21.6031 21.8297 20.5117 20.7383 20.5117 19.3912C20.5117 18.0423 21.6031 16.9526 22.9503 16.9526Z"
                fill="#0B9CE9"
              />
              <path
                d="M63.0269 25.999H65.9303L57.5422 7.53455C57.1989 6.77847 56.4445 6.29102 55.612 6.29102C54.7794 6.29102 54.0251 6.77847 53.6817 7.53633L45.3203 25.999H48.1685L50.4617 20.7794H60.732L63.0269 25.999ZM51.433 18.5716L55.5977 9.09298L59.7624 18.5716H51.433Z"
                fill="#001997"
              />
              <path
                d="M79.2512 5.52246V13.5957C78.7548 12.9552 78.1678 12.4429 77.4846 12.0622C76.4919 11.5107 75.3783 11.2349 74.1454 11.2349C72.7293 11.2349 71.4644 11.548 70.3507 12.1725C69.2371 12.7987 68.3582 13.6668 67.716 14.7805C67.072 15.8942 66.75 17.1946 66.75 18.6855C66.75 20.1763 67.072 21.4821 67.716 22.6046C68.36 23.7272 69.2389 24.6007 70.3507 25.2269C71.4644 25.8531 72.7275 26.1645 74.1454 26.1645C75.4156 26.1645 76.5471 25.8834 77.5398 25.323C78.2549 24.9192 78.8598 24.373 79.3615 23.6881V25.999H81.9002V5.52246H79.2512ZM78.6303 21.4038C78.198 22.1866 77.6092 22.7879 76.8638 23.2113C76.1183 23.6347 75.2857 23.8464 74.366 23.8464C73.4284 23.8464 72.5905 23.6347 71.854 23.2113C71.1175 22.7879 70.5286 22.1866 70.0875 21.4038C69.6463 20.6228 69.4257 19.7155 69.4257 18.6855C69.4257 17.6376 69.6463 16.7303 70.0875 15.9671C70.5286 15.2039 71.1175 14.6115 71.854 14.1881C72.5888 13.7647 73.4267 13.553 74.366 13.553C75.2857 13.553 76.1183 13.7647 76.8638 14.1881C77.6092 14.6115 78.198 15.2039 78.6303 15.9671C79.0626 16.7303 79.2797 17.6376 79.2797 18.6855C79.2779 19.7155 79.0608 20.621 78.6303 21.4038Z"
                fill="#001997"
              />
              <path
                d="M113.224 11.3717V13.5937C112.728 12.9532 112.14 12.4409 111.457 12.0602C110.465 11.5087 109.351 11.2329 108.118 11.2329C106.702 11.2329 105.437 11.546 104.323 12.1705C103.21 12.7967 102.331 13.6648 101.689 14.7785C101.045 15.8922 100.723 17.1926 100.723 18.6835C100.723 20.1743 101.045 21.4801 101.689 22.6027C102.333 23.7252 103.212 24.5987 104.323 25.2249C105.437 25.8511 106.7 26.1625 108.118 26.1625C109.388 26.1625 110.52 25.8814 111.512 25.321C112.228 24.9172 112.832 24.371 113.334 23.6861V25.997H115.873V11.3717H113.224ZM112.603 21.4036C112.171 22.1864 111.582 22.7877 110.836 23.2111C110.091 23.6345 109.258 23.8462 108.339 23.8462C107.401 23.8462 106.563 23.6345 105.827 23.2111C105.09 22.7877 104.501 22.1864 104.06 21.4036C103.619 20.6226 103.398 19.7153 103.398 18.6852C103.398 17.6374 103.619 16.7301 104.06 15.9669C104.501 15.2037 105.09 14.6113 105.827 14.1879C106.561 13.7645 107.399 13.5528 108.339 13.5528C109.258 13.5528 110.091 13.7645 110.836 14.1879C111.582 14.6113 112.171 15.2037 112.603 15.9669C113.035 16.7301 113.252 17.6374 113.252 18.6852C113.251 19.7153 113.033 20.6208 112.603 21.4036Z"
                fill="#001997"
              />
              <path
                d="M97.3407 11.3721L92.1406 23.2595L87.0384 11.3721H84.2773L90.2122 24.9282C90.5413 25.6808 91.2849 26.1664 92.1068 26.1664C92.9287 26.1664 93.6724 25.6808 94.0015 24.9282L99.9363 11.3721H97.3407Z"
                fill="#001997"
              />
              <path
                d="M132.651 14.0206C132.135 13.0831 131.423 12.3839 130.512 11.9232C129.602 11.4642 128.548 11.2329 127.353 11.2329C126.028 11.2329 124.869 11.4998 123.875 12.0335C123.133 12.432 122.535 12.9479 122.082 13.583V11.3717H119.543V25.997H122.192V18.4629C122.192 17.3954 122.381 16.5042 122.758 15.7854C123.135 15.0685 123.672 14.5259 124.371 14.1576C125.07 13.7894 125.889 13.6061 126.828 13.6061C128.079 13.6061 129.05 13.9655 129.739 14.6824C130.429 15.3994 130.774 16.4668 130.774 17.8829V25.997H133.423V17.5805C133.423 16.1466 133.165 14.96 132.651 14.0206Z"
                fill="#001997"
              />
              <path
                d="M144.688 23.2382C144.137 23.699 143.446 23.9285 142.619 23.9285C141.883 23.9285 141.317 23.7168 140.922 23.2933C140.525 22.8699 140.328 22.2633 140.328 21.4716V13.5514H144.523V11.3721H140.328V7.4458H137.679V11.3721H135.195V13.5514H137.679V21.5819C137.679 23.0532 138.083 24.1846 138.894 24.9763C139.703 25.768 140.844 26.1629 142.315 26.1629C142.922 26.1629 143.507 26.0793 144.067 25.9138C144.628 25.7484 145.112 25.4904 145.515 25.1418L144.688 23.2382Z"
                fill="#001997"
              />
              <path
                d="M150.994 23.5974V17.3601H160.68V15.0154H150.994V9.08235H161.867V6.68066H148.234V25.9991H162.253V23.5974H150.994Z"
                fill="#001997"
              />
              <path
                d="M176.728 5.52246V13.5957C176.231 12.9552 175.644 12.4429 174.961 12.0622C173.969 11.5107 172.855 11.2349 171.622 11.2349C170.206 11.2349 168.941 11.548 167.827 12.1725C166.714 12.7987 165.835 13.6668 165.193 14.7805C164.549 15.8942 164.227 17.1946 164.227 18.6855C164.227 20.1763 164.549 21.4821 165.193 22.6046C165.837 23.7272 166.715 24.6007 167.827 25.2269C168.941 25.8531 170.204 26.1645 171.622 26.1645C172.892 26.1645 174.024 25.8834 175.016 25.323C175.732 24.9192 176.336 24.373 176.838 23.6881V25.999H179.377V5.52246H176.728ZM176.107 21.4038C175.675 22.1866 175.086 22.7879 174.34 23.2113C173.595 23.6347 172.762 23.8464 171.843 23.8464C170.905 23.8464 170.067 23.6347 169.331 23.2113C168.594 22.7879 168.005 22.1866 167.564 21.4038C167.123 20.6228 166.902 19.7155 166.902 18.6855C166.902 17.6376 167.123 16.7303 167.564 15.9671C168.005 15.2039 168.594 14.6115 169.331 14.1881C170.065 13.7647 170.903 13.553 171.843 13.553C172.762 13.553 173.595 13.7647 174.34 14.1881C175.086 14.6115 175.675 15.2039 176.107 15.9671C176.539 16.7303 176.756 17.6376 176.756 18.6855C176.756 19.7155 176.539 20.621 176.107 21.4038Z"
                fill="#001997"
              />
              <path
                d="M194.963 11.3717V13.6132C194.418 12.9176 193.757 12.3768 192.976 11.9926C191.946 11.4873 190.805 11.2329 189.553 11.2329C188.137 11.2329 186.872 11.5282 185.758 12.1153C184.644 12.7042 183.762 13.5278 183.109 14.5846C182.456 15.6431 182.129 16.8795 182.129 18.2956C182.129 19.6939 182.454 20.9268 183.109 21.9942C183.762 23.0616 184.644 23.8942 185.758 24.492C186.872 25.0897 188.135 25.3886 189.553 25.3886C190.803 25.3886 191.944 25.1271 192.976 24.6023C193.693 24.2376 194.308 23.7412 194.824 23.1221V24.2856C194.824 25.9419 194.418 27.173 193.609 27.9842C192.799 28.7937 191.529 29.1975 189.8 29.1975C188.715 29.1975 187.676 29.0267 186.681 28.6869C185.689 28.3471 184.851 27.881 184.169 27.2939L182.899 29.3363C183.691 30.0354 184.716 30.5727 185.977 30.9498C187.236 31.327 188.539 31.5156 189.882 31.5156C192.365 31.5156 194.251 30.9089 195.539 29.6938C196.827 28.4788 197.471 26.5841 197.471 24.0081V11.3681H194.963V11.3717ZM194.232 20.7827C193.799 21.4997 193.205 22.0618 192.451 22.4657C191.696 22.8713 190.832 23.0723 189.857 23.0723C188.882 23.0723 188.012 22.8695 187.249 22.4657C186.486 22.0618 185.888 21.4997 185.456 20.7827C185.023 20.0658 184.806 19.2367 184.806 18.2992C184.806 17.3616 185.022 16.5326 185.456 15.8157C185.888 15.0987 186.486 14.5419 187.249 14.1452C188.012 13.7502 188.882 13.551 189.857 13.551C190.832 13.551 191.696 13.7484 192.451 14.1452C193.205 14.5401 193.798 15.0969 194.232 15.8157C194.664 16.5326 194.881 17.3616 194.881 18.2992C194.881 19.2367 194.664 20.0658 194.232 20.7827Z"
                fill="#001997"
              />
              <path
                d="M214.077 14.8071C213.459 13.6757 212.609 12.7968 211.524 12.1724C210.438 11.548 209.188 11.2349 207.77 11.2349C206.372 11.2349 205.116 11.5515 204.004 12.1866C202.89 12.8218 202.017 13.7006 201.381 14.8214C200.746 15.9439 200.43 17.232 200.43 18.6854C200.43 20.1389 200.755 21.4269 201.41 22.5495C202.063 23.672 202.983 24.5544 204.169 25.1984C205.356 25.8424 206.731 26.1644 208.295 26.1644C209.508 26.1644 210.607 25.9616 211.593 25.5578C212.577 25.1539 213.401 24.5651 214.062 23.7912L212.6 22.0798C212.066 22.6686 211.445 23.1098 210.737 23.4052C210.029 23.6987 209.243 23.8464 208.378 23.8464C207.331 23.8464 206.4 23.6347 205.591 23.2113C204.781 22.7878 204.151 22.1954 203.7 21.4322C203.367 20.8701 203.159 20.2474 203.072 19.5696H214.947C214.964 19.4415 214.979 19.3027 214.987 19.1551C214.996 19.0074 215.002 18.8793 215.002 18.769C215.002 17.2604 214.694 15.9386 214.077 14.8071ZM205.315 14.0902C206.032 13.6757 206.85 13.4693 207.772 13.4693C208.709 13.4693 209.533 13.6757 210.241 14.0902C210.949 14.5047 211.506 15.0793 211.91 15.8158C212.216 16.3745 212.401 16.99 212.465 17.6643H203.064C203.141 16.9936 203.329 16.3816 203.63 15.8283C204.036 15.0847 204.598 14.5047 205.315 14.0902Z"
                fill="#001997"
              />
              <path
                d="M237.66 26.252C235.662 26.252 233.954 25.8413 232.536 25.02C231.117 24.1987 230.025 23.032 229.26 21.52C228.513 19.9893 228.14 18.188 228.14 16.116C228.14 14.044 228.513 12.252 229.26 10.74C230.025 9.228 231.117 8.06133 232.536 7.24C233.954 6.41867 235.662 6.008 237.66 6.008C239.004 6.008 240.254 6.22267 241.412 6.652C242.588 7.06267 243.568 7.66 244.352 8.444L243.344 10.768C242.485 10.0027 241.598 9.452 240.684 9.116C239.788 8.76133 238.808 8.584 237.744 8.584C235.616 8.584 233.992 9.23733 232.872 10.544C231.752 11.8507 231.192 13.708 231.192 16.116C231.192 18.524 231.752 20.3907 232.872 21.716C233.992 23.0227 235.616 23.676 237.744 23.676C238.808 23.676 239.788 23.508 240.684 23.172C241.598 22.8173 242.485 22.2573 243.344 21.492L244.352 23.816C243.568 24.5813 242.588 25.1787 241.412 25.608C240.254 26.0373 239.004 26.252 237.66 26.252ZM247.734 26V6.26H255.91C258.038 6.26 259.68 6.792 260.838 7.856C261.995 8.90133 262.574 10.376 262.574 12.28C262.574 14.2027 261.995 15.696 260.838 16.76C259.68 17.8053 258.038 18.328 255.91 18.328H250.646V26H247.734ZM250.646 16.004H255.49C258.327 16.004 259.746 14.7627 259.746 12.28C259.746 9.816 258.327 8.584 255.49 8.584H250.646V16.004ZM269.995 26V8.696H262.995V6.26H279.879V8.696H272.879V26H269.995Z"
                fill="#001997"
              />
              <path
                d="M214.849 8.024V3.194H213.001V2.13H217.999V3.194H216.137V8.024H214.849ZM218.853 8.024V2.13H219.875L221.891 5.672L223.907 2.13H224.915V8.024H223.795V4.328L222.213 7.1H221.569L219.973 4.342V8.024H218.853Z"
                fill="#001997"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1_5286"
                  x1="4.87243"
                  y1="37.5677"
                  x2="33.2131"
                  y2="9.22231"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop
                    offset="0.06404"
                    stop-color="#001997"
                    stop-opacity="0"
                  />
                  <stop
                    offset="0.12664"
                    stop-color="#001997"
                    stop-opacity="0.04268"
                  />
                  <stop
                    offset="0.21397"
                    stop-color="#001997"
                    stop-opacity="0.16247"
                  />
                  <stop
                    offset="0.31582"
                    stop-color="#001997"
                    stop-opacity="0.35922"
                  />
                  <stop
                    offset="0.42866"
                    stop-color="#001997"
                    stop-opacity="0.63316"
                  />
                  <stop
                    offset="0.54585"
                    stop-color="#001997"
                    stop-opacity="0.97"
                  />
                  <stop offset="1" stop-color="#001997" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      }
      styles={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <div>
        <div className="flex justify-center sm:justify-end pb-8">
          <Image
            style={{ marginTop: "6px", marginBottom: "28px" }}
            src={logo}
            alt="Logo"
            preview={false}
            className=" rounded-md"
            width={200}
            height={60}
          />
        </div>
      </div>
      <div className="w-full overflow-x-auto">
        <div className="min-w-[600px] grid grid-cols-2 gap-y-4 gap-x-12 text-sm bg-slate-100 p-5 rounded-md">
          <div className="flex items-center gap-2">
            <div className="font-semibold w-[130px] text-gray-700">
              Order Number :
            </div>
            <div className="text-gray-900">{OrderNumber || "-"}</div>
          </div>

          <div className="flex items-center gap-2">
            <div className="font-semibold w-[130px] text-gray-700">
              Invoice Number :
            </div>
            <div className="text-gray-900">
              {orderDetails?.header?.invoice_id || "-"}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="font-semibold w-[130px] text-gray-700">
              Order Date :
            </div>
            <div className="text-gray-900">
              {orderDate ? moment.utc(orderDate).format("MM-DD-YYYY") : "-"}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="font-semibold w-[130px] text-gray-700">
              Invoice Date :
            </div>
            <div className="text-gray-900">
              {orderDetails?.header?.invoice_date
                ? moment.utc(orderDetails?.header?.invoice_date).format(
                    "MM-DD-YYYY",
                  )
                : "-"}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="font-semibold w-[130px] text-gray-700">
              Supplier :
            </div>
            <div className="text-gray-900">
              {orderDetails?.header?.supplier ?? "-"}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="font-semibold w-[130px] text-gray-700">
              Status :
            </div>
            <div className="text-gray-900">{orderStatus  === "ORDER_SENT" ? "ORDER SENT":
                orderStatus === "ACK_RECEIVED"? "ACK RECEIVED":orderStatus
            }</div>
          </div>
        </div>
      </div>
      <div className=" flex items-center justify-center m-4 my-12">
        <Steps
          current={currentStep}
          status={stepStatus}
          labelPlacement="vertical"
          className="custom-order-steps w-[800px] "
          items={steps}
          responsive
          size="small"
        />
      </div>
         <div className="flex justify-end">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                className="w-[150px] ml-4"
              >
                Download pdf
              </Button>

            </div>
      <Table
        columns={columns}
        dataSource={orderDetails?.data}
        rowKey="product_code"
        scroll={{ x: "max-content" }}
        // className="custom-table user-tbl"
        className="custom-tablenew user-tblNew grouped-metrics-table"
        loading={loading}
        pagination={{
          current,
          total,
          showSizeChanger: true,
          pageSize,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        onChange={(pagination) =>
          onPageChange(pagination.current, pagination.pageSize)
        }
      />

      <div className="w-full max-w-3xl bg-white shadow-md rounded-xl p-5 border border-gray-200">
        {/* <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-800">
            Total Amount : { `$ ${(orderDetails?.totals?.total_ordered_amount)?.toFixed(2)}`  ?? "-"}
          </h3>
        </div> */}

        <div className="flex md:flex-row flex-col gap-4 ">
          <div className="w-full bg-gray-50 rounded-lg p-4 text-center border border-gray-100">
            <p className="text-sm text-gray-500">Total Ordered Amount</p>
            <p className="text-lg font-semibold text-gray-800 mt-1">
              {orderDetails?.totals?.total_ordered_amount !== undefined &&
              orderDetails?.totals?.total_ordered_amount !== null &&
              orderDetails?.totals?.total_ordered_amount !== 0
                ? `$ ${orderDetails.totals.total_ordered_amount?.toFixed(2)}`
                : "-"}
            </p>
          </div>

          <div className="w-full bg-blue-50 rounded-lg p-4 text-center border border-blue-100">
            <p className="text-sm text-blue-600">Total Invoiced Amount</p>
            <p className="text-lg font-semibold text-blue-700 mt-1">
              {orderDetails?.totals?.total_invoiced_amount !== undefined &&
              orderDetails?.totals?.total_invoiced_amount !== null &&
              orderDetails?.totals?.total_invoiced_amount !== 0
                ? `$ ${orderDetails.totals.total_invoiced_amount?.toFixed(2)}`
                : "-"}
            </p>
          </div>

          {/* <div className="w-full bg-green-50 rounded-lg p-4 text-center border border-green-100">
            <p className="text-sm text-green-600">Shipment Amount</p>
            <p className="text-lg font-semibold text-green-700 mt-1">{`$ ${orderDetails?.totals?.total_shipped_amount?.toFixed(2)}` ?? "-"}</p>
          </div> */}
        </div>
      </div>
    </Modal>
  );
};

export default PurchaseHistoryModal;
